// AI: justified because the generated client (`@app/api-client/generated`) is not
// available until `pnpm api:generate` has been run at least once. After the first
// generation, this file MUST be deleted and the generated hooks used instead.

import { apiAxios } from '@app/api-client';
import type { CompanyDto, CompanyUpdateInput } from '@app/contracts';

export const fetchCompany = (): Promise<CompanyDto> =>
  apiAxios<CompanyDto>({ url: '/api/v1/company', method: 'GET' });

export const updateCompany = (input: CompanyUpdateInput): Promise<CompanyDto> =>
  apiAxios<CompanyDto>({ url: '/api/v1/company', method: 'PATCH', data: input });
